import React, {useRef, useEffect, useState} from "react";
import './MushroomAi.scss';

import Header from "../../components/Header";
import Button from "react-bootstrap/Button";
import mapboxgl from 'mapbox-gl'

import 'mapbox-gl/dist/mapbox-gl.css';
import Footer from "../../components/Footer";
import {useModal} from "../../components/ModalContext";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

let img_play = require("../../assets/home/play-button-icon.png");
let img_top = require("../../assets/mushroom/26.webp");
let icon_trial = require("../../assets/mushroom/27.png");
let icon_show = require("../../assets/mushroom/28.png");

function MushroomAi() {
    const {openModal} = useModal();
    const mapRef = useRef()
    const mapContainerRef = useRef();
    const [showMap, setShowMap] = useState(true);


    useEffect(() => {
        mapboxgl.accessToken = 'pk.eyJ1IjoiZ2VvdGlja2V0c3JsIiwiYSI6ImNsenFvcmh1dzF0bDgyanFyd3lhaGhtNWMifQ.Lt-gOko0rO-VuTBu3kKD1w'
        mapRef.current = new mapboxgl.Map({
            container: mapContainerRef.current,
            center: [12.2558141, 41.9097306],
            zoom: 5
        });

        return () => {
            mapRef.current.remove()
        }
    }, [])


    return (
        <div style={{backgroundColor: "#fafafa"}}>
            <Header/>
            <div className="video-section">
                <img className="background-video" src={img_top}/>

                <div className="overlay-content background">
                    <div>
                        <img className={"image-play"} src={img_play} alt="Card image cap"
                             onClick={() => openModal("video-home")}/>
                        <div className={"container"}>
                            <div style={{flex: 1}}>
                                <h1 className="title">Benvenuto nella<br/>
                                    <b>Tabella Crescite <span className={"orange"}>Intelligente</span></b></h1>
                            </div>
                            <h4>La Tabella Crescite Intelligente incrocia migliaia di dati ambientali
                                per prevedere la crescita fungina.
                                Saprai in anticipo quando nasceranno, e dove.</h4>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"container mt-4 mb-4"}>
                <div style={{width: '100%', height: 640, position: 'relative'}}>
                    <div id='map-container' className={"map"} ref={mapContainerRef}/>
                    <div className={"map-alert " + (!showMap ? "d-none" : "")}>
                        <span>Stai consultando la versione gratuita</span>
                        <span>Data della crescita fungina analizzata: 06/05/2025</span>
                        <span className={"orange"}>Se vuoi sapere dove stanno nascendo oggi:</span>
                        <Button className={"btn-success"}>PROVA SUBITO LA VERSIONE COMPLETA</Button>
                    </div>
                    <div className={"map-overlay " + (showMap ? "d-none" : "")}>

                        <div className="map-container">
                            <span className={"title"}><b>Attenzione:</b> la Tabella Crescita Intelligente <span
                                className={"orange"}>aggiornata ad oggi</span> è disponibile solo per gli
                            utenti di Geoticket+</span>
                            <div className="button-group">
                                <div>
                                    <div>
                                        <img src={icon_trial} alt="Card image cap"/>
                                    </div>
                                    <Button className={"btn-orange"} href={"/premium"}>AVVIA LA TUA PROVA
                                        GRATUITA</Button>
                                </div>
                                <div>
                                    <div>
                                        <img src={icon_show} alt="Card image cap"/>
                                    </div>
                                    <Button className={"btn-success"} onClick={setShowMap}>CONSULTA COMUNQUE LA MAPPA
                                        (DATI NON
                                        AGGIORNATI)</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
}

export default MushroomAi;